import { DropdownOption } from '@Calix-Commerce/design-system/components';
import { CREATED_BY_ALL_FILTER } from 'pages/Quotes/filters';
import { Quote } from 'types';

// Generates options to be used on the filter dropdowns, based on a list of items
export const getCreatedByAndTagsOptions = (
  items: Quote[]
): { createdByOptions: DropdownOption[]; tagsOptions: DropdownOption[] } => {
  const uniqueNames: { [k: string]: DropdownOption } = {};
  const uniqueTags: { [k: string]: DropdownOption } = {};

  if (items.length) {
    for (const item of items) {
      // when the quoteList item is null, skip the current operation and continue to the next iteration
      if (!item) continue;

      const itemTags = item.tags || [];
      const name = item.preparedByName;

      uniqueNames[name] = { id: name, text: name };

      itemTags.forEach((tag) => {
        uniqueTags[tag] = { id: tag, text: tag };
      });
    }
  }

  return {
    createdByOptions: [
      { id: CREATED_BY_ALL_FILTER, text: 'Created by all' },
      ...Object.values(uniqueNames),
    ],
    tagsOptions: Object.values(uniqueTags),
  };
};
